<template>
  <q-input :model-value="modelValue" class="input-piece" dense filled v-on:keyup="$emit('update:modelValue', parseInt($event.target.value))" :disable="disabled" readonly>
    <template v-slot:append>
      <q-btn icon="remove" class="q-mr-xs" size="xs" color="primary" @click="decrease" dense :disable="disabled" />
      <q-btn icon="add" size="xs" color="primary" @click="increase" dense :disable="disabled" />
    </template>
  </q-input>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'InputPiece',

  props: {
    modelValue: {
      default: 1,
      required: true,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
  },

  methods: {
    increase() {
      this.$emit('update:modelValue', this.modelValue + 1);
      this.$emit('increase');
    },
    decrease() {
      this.$emit('update:modelValue', this.modelValue - 1);
      this.$emit('decrease');
    },
  },

  watch: {
    /**
     * Adet girişini sadece numara olarak al
     */
    modelValue(val) {
      let value = val;
      if (val < 1 || isNaN(val + 1)) {
        value = 1;
      }
      this.$emit('update:modelValue', parseInt(value));
    },
  },
});
</script>

<style scoped>
.input-piece ::v-deep(input) {
  font-weight: 700;
}
</style>
